import { Divider, Flex } from "antd";
import { stat } from "fs";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';

import { ArrowLeftOutlined } from '@ant-design/icons';

const Profile = () => {
  // const [searchParams] = useSearchParams();
  // const data = searchParams.get('profile') || 'No Data Passed';
  const location = useLocation();
  const state = location.state;
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  }
  // console.log(state);
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="about-container">
      <div className="content">
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <p style={{ display: 'flex' }}>
            <ArrowLeftOutlined onClick={goBack}></ArrowLeftOutlined>Go back
          </p>

        </div>

        <div className="profile-header">
          <img
            src={state.src}
            alt="Profile"
            className="profile-picture"
          />
          <h1 className="profile-name">{state.name}</h1>
          <p className="profile-bio">
            {state.title}
          </p>
        </div>
        <div className="profile-details">
          <h2 className="details-title">Details</h2>
          <ul className="details-list">
            <li><strong>Email:</strong> {state.email}</li>
            {/* <li><strong>Phone:</strong> {state.phone}</li> */}
            <li><strong>Address:</strong> {state.address}</li>
            <li><strong>Bio: </strong>{state.bio}</li>

          </ul>
        </div>
      </div>

    </div>
  )
}


export default Profile;